<div
  style="
    position: -webkit-sticky; /* Safari */
    position: fixed;
    width: 250px;
    bottom: 40px;
    right: 20px;
    z-index: 10000;
  "
  *ngIf="!displayTestDecisionsFooter"
>
  <button
    (click)="toggleDisplayTestDecisionsFooter()"
    class="btn text-uppercase"
    style="color: white; width: 80%; border: 1px solid; background: #00001f"
    [ngStyle]="{ 'border-color': rgbColor }"
  >
    {{ texts?.openTestEnvironment }}
  </button>
</div>

<div
  class="test-decisions-footer"
  [style.background-color]="rgbColor"
  *ngIf="displayTestDecisionsFooter"
>
  <div style="display: flex; align-items: center; justify-content: center">
    <button
      class="btn text-uppercase create-test-decision-button mx-2"
      (click)="openCreateDialog()"
      *ngIf="data?.length < 10"
    >
      {{ texts?.createTestEnvironment }}
    </button>
    <button
      type="button"
      class="btn text-uppercase create-test-decision-button mx-2"
      [ngbPopover]="popContent"
      (shown)="popupShown()"
      (hidden)="popupHidden()"
      *ngIf="data?.length > 0"
    >
      <span *ngIf="isTeamDecisionSelected()">{{ texts?.access }}</span>
      <span *ngIf="!isTeamDecisionSelected()">{{
        getSelectedtestDecision()
      }}</span>

      <img
        [ngStyle]="{ transform: state === 'rotated' ? 'rotate(180deg)' : '' }"
        [@rotatedState]="state"
        src="img/dropdownarrow.svg"
        width="24"
        height="15"
        class="mx-2"
        alt=""
        aria-hidden="true"
      />
    </button>
    <button
      class="btn text-uppercase create-test-decision-button mx-2"
      (click)="openTeamDecision()"
    >
      {{ texts?.quitTestEnvironment }}
    </button>
  </div>
</div>
<app-create-test-decision-dialog
  #dialog
  (confirmed)="dialogConfirmed($event)"
  [texts]="texts"
></app-create-test-decision-dialog>

<ng-template #popContent>
  <div class="test-decisions-list">
    <div *ngFor="let itm of data" style="padding: 5px">
      <button
        type="button"
        (click)="openTestDecision(itm.id)"
        [ngStyle]="{ 'font-weight': itm.current ? '900' : '' }"
        style="border: none; background: none; padding: 0;"
        >{{ itm.name }}</button
      >
    </div>
  </div>
</ng-template>
